export var APP_VERSION = '1.0.0';
export var ENABLE_REDUX_DEV_TOOLS = true;
export var THEMES = { LIGHT: 'LIGHT', ONE_DARK: 'ONE_DARK', UNICORN: 'UNICORN' };
export var GLOBAL_DATA_KEY = 'JBe4n9GSJT2fiadbN0rc';
export var TEMP_EXHIBITION_KEY = 'dhlAjk0AHHabX8MJXgjqZH0955J2';
export var SDK_KEY = '4gw9zba9tq90g901et65gm4mc';
